export default "__VITE_ASSET__2dc37c5b__"